import { render, staticRenderFns } from "./TrustDialog.vue?vue&type=template&id=04b3ce13&scoped=true"
import script from "./TrustDialog.vue?vue&type=script&lang=js"
export * from "./TrustDialog.vue?vue&type=script&lang=js"
import style0 from "./TrustDialog.vue?vue&type=style&index=0&id=04b3ce13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b3ce13",
  null
  
)

export default component.exports